import { Component, OnInit } from "@angular/core";
import { Platform } from "@ionic/angular";
import { App } from "@capacitor/app";
import { ScreenOrientation } from "@awesome-cordova-plugins/screen-orientation/ngx";

import { AppstorageTsService } from "src/app/services/appstorage/appstorage.ts.service";
import { ConfigService } from "src/app/services/config/config.service";
import { JurisdictionService } from "src/app/services/geo/jurisdiction.service";
import { LocationWarningService } from "src/app/services/location-warning/location-warning.service";
import { MobileToolsService } from "src/app/services/mobile-tools/mobile-tools.service";
import { Navigator } from "src/app/services/routing/navigator";
import { SiteLocationService } from "src/app/services/site-location/site-location.service";
import { UniqueIDService } from "src/app/services/unique-id/unique-id.service";
import { GeoLocationStrategyService } from "src/app/services/geo-location-strategy/geo-location-strategy.service";
import { GeoLocationControllerService } from "src/app/services/geo-location/geo-location-controller.service";
import { GeoLocationPreRequestService } from "src/app/services/geo-location/geo-location-pre-request.service";
import { GeoLocationSDKInitService } from "src/app/services/geo-location/geo-location-sdkinit.service";

@Component({
  selector: "app-tab-landing",
  templateUrl: "./tab-landing.page.html",
  styleUrls: ["./tab-landing.page.scss"],
})
export class TabLandingPage implements OnInit {
  public isAuthenticated: boolean = false;
  public splashPageSettings;
  public displayButtons: Boolean = true;
  public splashPageState = "";
  public isMobile: Boolean = false;
  public isAndroidApp = false;
  public isMobileApp: boolean = false;
  public versionNumber: string;

  public currentYear: any;
  public stateName = "";
  private timeout = 1000;

  public tapCount: number = 0;
  public tapTimeoutID: any = 0;
  public deviceId: any;
  public environment: any = "";
  public showDeviceId: boolean = false;
  public isEnvSelected: boolean = false;
  public statesMap: { [key: string]: string };
  public stateLogosMap: { [key: string]: string[] } = {
    PA: ["assets/images/PGCB.png", "assets/images/rg_logo.png"],
    NJ: ["assets/images/dge_logo.png", "assets/images/njrglogo.png"],
  };
  public displayLoadingText: Boolean = true;

  public mobileStyle: string;
  public selectionText = "Select a state to play in";
  constructor(
    private appstorageTsService: AppstorageTsService,
    private config: ConfigService,
    private geoJurisdictionService: JurisdictionService,
    private locationWarningService: LocationWarningService,
    private mobileTools: MobileToolsService,
    private navigator: Navigator,
    private platform: Platform,
    private geoLocationStrategyService: GeoLocationStrategyService,
    private geoLocationControllerService: GeoLocationControllerService,
    private geoLocationPreRequestService: GeoLocationPreRequestService,
    private geoLocationSDKInitService: GeoLocationSDKInitService,
    private screenOrientation: ScreenOrientation,
    private siteLocationService: SiteLocationService,
    private uniqueIDProvider: UniqueIDService,
  ) {
    this.getLandingpageSettings();

    this.currentYear = new Date().getFullYear();
    this.statesMap = this.siteLocationService.statesMap;
    this.mobileStyle = this.platform.is("mobile") ? "mobile" : "";
    this.mobileStyle +=
      this.screenOrientation.type == "portrait-primary"
        ? " from-portait"
        : " from-landscape";

    if (this.platform.is("mobile")) {
      this.screenOrientation.onChange().subscribe(() => {
        this.mobileStyle +=
          this.screenOrientation.type == "portrait-primary"
            ? "'mobile from-portait"
            : " mobile from-landscape";
      });
    }
  }

  async ngOnInit() {
    this.isMobile = this.platform.is("mobile");
    this.isAndroidApp = this.platform.is('capacitor') && this.platform.is('android')
    if (this.platform.is("capacitor")) {
      this.isMobileApp = true;
      const info = await App.getInfo()
      this.versionNumber = info.version;

      this.selectionText = this.config.getSelectionText();
      this.checkLoadText();
      this.uniqueIDProvider.getSelectorID().then(
        (response) => {
          console.log("uniqueIDProvider.getSelectorID()", response);
          this.deviceId = response;
        },
        (reject) => {
          console.log("error uniqueIDProvider.getSelectorID()", reject);
          this.deviceId = "Not available!";
        }
      );

      await this.mobileTools.checkEnvironmentSelector();
      console.log("show selector?", this.mobileTools.shouldSelectEnvironment);

      if (!this.mobileTools.shouldSelectEnvironment) {
        console.log("splashPageInit for mobile app");
        this.splashPageInit();
      }
      //geo check
      if (this.platform.is("android")) {
        const locationWarningCheck = this.config.getConfig().FEATURE_LOCATION_WARNING_CHECK === "1" ? true : false;
        if (locationWarningCheck) {
          this.locationWarningService.initGeoVerificationProcess();
        } else {
           if (this.geoLocationStrategyService.isGeoOptimizationEnabled()) {
            this.requestOptimizedAndroidGeoPermissions()
          } else {
            this.requestAndroidGeoPermissions();
          }
        }
      }
      this.setIOSAppIcon();
    } else {
      console.log("splashPageInit for web");
      this.splashPageInit();
    }
  }

  private getLandingpageSettings(): void {
    const raw = this.config?.getConfig()?.FEATURE_APP_SPLASH_SETTINGS;

    try {
      if (raw) {
        this.splashPageSettings = JSON.parse(raw);
      }
    } catch (e) {
      console.error("Invalid FEATURE_APP_SPLASH_SETTINGS JSON:", e);
    }
  }

  private setIOSAppIcon() {
    if (this.platform.is("ios")) {
      this.mobileTools.setIOSAppIcon();
    }
  }
  private requestAndroidGeoPermissions() {
    if (this.geoJurisdictionService.shouldDisplayPermissionReason()) {
      this.geoJurisdictionService
        .displayPermissionReason()
        .then((acceptsReason: any) => {
          console.log("displayPermissionReason ", acceptsReason)
          this.geoJurisdictionService._didUserAcceptReason = acceptsReason;
          //first dialog allow
          if (acceptsReason && "data" in acceptsReason && acceptsReason.data) {
            console.log("Requesting native permissions")
            this.geoJurisdictionService.requestNativePermissionsDialog(
              () => {
                /*all good, continue*/
                this.geoJurisdictionService.setAcceptReason(true);
              },
              (deny) => {
                console.log("Android geo ", deny);

                return this.navigator.navigateTo("AppRestrictedComponent", {
                  customModalClass: "app-restricted-screen",
                  animated: false,
                });

              }
            );

          } else {
            // first dialog cancel
            return this.navigator.navigateTo("AppRestrictedComponent", {
              customModalClass: "app-restricted-screen",
              animated: false,
            });
          }
        });
    }
  }

  private requestOptimizedAndroidGeoPermissions() {
    if (this.geoLocationPreRequestService.shouldDisplayPermissionReason()) {
      this.geoLocationPreRequestService
        .displayPermissionReason()
        .then(async (acceptsReason: any) => {
          console.log("displayPermissionReason ", acceptsReason)
          //first dialog allow
          if (acceptsReason && "data" in acceptsReason && acceptsReason.data) {
            console.log("Requesting native permissions");
            const initGeoComply = await this.geoLocationSDKInitService.initializeGeoComplyForMobileApp();
            if (initGeoComply) {
              const geoComplyClient = this.geoLocationSDKInitService.getGeoComplyWindowClient();
              this.geoLocationControllerService.requestRuntimePermissions(
                () => {
                  this.geoLocationPreRequestService.setAcceptReason(true);
                },
                (deny) => {
                  console.log("Android geo ", deny);
                  return this.navigator.navigateTo("AppRestrictedComponent", {
                    customModalClass: "app-restricted-screen",
                    animated: false,
                  });
                }
              );
            }
          } else {
            // first dialog cancel
            return this.navigator.navigateTo("AppRestrictedComponent", {
              customModalClass: "app-restricted-screen",
              animated: false,
            });
          }
        });
    }
  }

  private splashPageInit() {
    if (this.platform.is("capacitor")) {
      this.hasNoJurisdictionCheck();
      this.splashPageState = this.appstorageTsService.getSplashPageState();
      this.checkLoadText();
      // this.marketingService.initialize();
      this.appstorageTsService.getJurisdiction().then((stateObj) => {
        if (!this.splashPageState) {
          if (
            stateObj &&
            stateObj !== null &&
            stateObj !== undefined &&
            stateObj.value !== null &&
            stateObj.value !== undefined
          ) {
            this.splashPageState = stateObj.value;
            this.setStateName(this.splashPageState);
            setTimeout(() => {
              this.goTo("", stateObj.value);
            }, this.timeout);
          } else {
            this.getLandingpageSettings();
          }
        } else {
          this.setStateName(this.splashPageState);
          setTimeout(() => {
            this.goTo("", this.splashPageState);
          }, this.timeout);
        }
      });
    } else {
      //web - remember the user selection for splash site
      this.appstorageTsService.getWebSplashSelection().then((stateObj) => {
        this.splashPageState = stateObj;
        if (!this.splashPageState) {
          if (stateObj && !stateObj) {
            this.splashPageState = stateObj;
            this.setStateName(this.splashPageState);
            let goToURL = this.getStoredStateURL(this.splashPageState);
            setTimeout(() => {
              this.goTo(goToURL, stateObj);
              this.splashPageState;
            }, this.timeout);
          } else {
            this.getLandingpageSettings();
          }
        } else {
          this.setStateName(this.splashPageState);
          const goToURL = this.getStoredStateURL(this.splashPageState);
          console.log(goToURL);
          setTimeout(() => {
            this.goTo(goToURL, this.splashPageState);
          }, this.timeout);
        }
      });
    }
  }
  private checkLoadText() {
    this.displayLoadingText = !this.splashPageSettings?.some(
      (i) => i.displayLoadingText === "0"
    );
  }

  public goTo(url?, stateCode?) {
    console.log("TabLandingPage goTo", url, stateCode, this.environment);
    this.siteLocationService.goTo(url, stateCode, this.environment);
  }
  private hasNoJurisdictionCheck() {
    if (this.config.clientAppWithNoJurisdiction()) {
      return this.goTo("", "");
    }
  }
  private setStateName(state) {
    this.stateName = this.statesMap[state];
  }

  //web - to retrieve stored jurisdiction state URL
  public getStoredStateURL(stateObj) {
    const redirectPathURL = this.splashPageSettings?.filter(
      (o) => o.jurisdiction === stateObj
    );
    if (redirectPathURL) return redirectPathURL[0].url;

    return window.location.href;
  }

  // environment selector logic
  onLogoTap() {
    if (this.platform.is("capacitor")) {
      this.tapCount += 1;
      // console.log("environment-selector onLogoTap", this.tapCount)

      clearTimeout(this.tapTimeoutID);

      if (this.tapCount >= 10) {
        this.showDeviceId = true;
      } else {
        this.tapTimeoutID = setTimeout(() => {
          this.tapCount = 0;
        }, 5000);
      }
    }
  }

  onEnvChange() {
    console.log("environment-selector onEnvChange", this.environment);
  }

  async onGoToEnvironment() {
    console.log("environment-selector onGoToEnvironment", this.environment);

    this.isEnvSelected = true;
    await this.config.reloadConfig(this.environment);
    this.config.isLoaded().then(() => {
      this.splashPageInit();
    });
  }
  isEnvironmentSelected() {
    return this.environment != "" ? true : false;
  }
  //end environment selector logic
}
